import { formatDate } from '../../../utils/date-format';
import { UserType } from './user-type';

export interface UserSummaryType {
  id: number;
  firstName: string;
  lastName: string;
  nationalId: string;
  phoneNumber: string;
  dateOfBirth: Date;
  email: string;
  fileUrl: string;

  city: string;
  street: string;
  houseNumber: string;
  flatNumber: string;
  postcode: string;
  gender: Gender;
  immigrateCountry: string | null;
  immigrateDate: Date | null;
  maritalStatus: MaritalStatus;

  role: UserType;
  courseStatusId?: number;
}

export enum Gender {
  Male = 'male',
  Female = 'female',
}

export enum MaritalStatus {
  Single = 'single',
  Married = 'married',
  Divorced = 'divorced',
  Widowed = 'widowed',
}

export const getUserSummaryValues = (user: UserSummaryType): string[] => {
  return [
    user.firstName + ' ' + user.lastName,
    user.nationalId,
    user.phoneNumber,
    formatDate(user.dateOfBirth),
    user.email,
  ];
};

export const getUserSummariesValues = (
  users: UserSummaryType[],
): string[][] => {
  return users.map(getUserSummaryValues);
};
